import { render, staticRenderFns } from "./DefaultCartsOverview.vue?vue&type=template&id=020687ea&"
import script from "./DefaultCartsOverview.vue?vue&type=script&lang=js&"
export * from "./DefaultCartsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports